<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="{
        slots: {
          buttons: 'toolbar_form',
        },
      }"
      :columns="tableColumns"
      :height="300"
      size="small"
      resizable
      border
      :header-cell-style="
        () => {
          return {
            backgroundColor: '#bd94c1',
            color: '#ffffff',
          }
        }
      "
    >
      <template v-slot:toolbar_form>
        <div class="side-frame-success">
          <span style="font-size: 14px; color: #606266">
            {{ $l('INDEX.table_label_product_information') || '产品信息' }}
          </span>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    orderPackingCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableColumns: tableColumns(this),
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$api
        .pendingOrderDemandPackingGoodsListApi({
          orderPackingCode: this.orderPackingCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
